import { useEffect, useState } from "react";

const Filters = (props) => {
  const [newValue, setNewValue] = useState("");
  const sluge = props.item.id;
  const featureChangeHandler = (event) => {
    const slugItem = event.target.getAttribute("slug");
    const inputType = event.target.getAttribute("inputType");
    // if (inputType === "INPUT") {
    if (props.HasManyInputData) {
      props.HasManyInputData(props.index, props.HasManyKey, String(slugItem));
    } else {
      const value = event.target.value;
      setNewValue(value);
      const inputDataNewObject = props.inputData;
      if (Object.keys(inputDataNewObject["filters"]).length) {
        let newFilters = inputDataNewObject["filters"].find(
          (item) => +item.id === +slugItem,
        );
        if (newFilters === undefined) {
          let newObject = { id: slugItem, value: value };
          inputDataNewObject["filters"].push(newObject);
        } else {
          if (value.length) {
            newFilters.value = value;
          } else {
            //delete object from array
            inputDataNewObject["filters"].splice(
              inputDataNewObject["filters"].findIndex(
                (index) => index.id === newFilters.id,
              ),
              1,
            );
          }
        }
      } else {
        inputDataNewObject["filters"] = [];
        let newObject = { id: slugItem, value: value };
        inputDataNewObject["filters"].push(newObject);
      }
    }
    // }
    // else if (inputType === "SELECT") {
    //     console.log(event.target.value)
    //     // setNewValue()
    // }
  };

  useEffect(() => {
    if (props.item.id) {
      setNewValue(props.item[props.item.id]);
    }
  }, []);
  return (
    <div>
      {props.item.type === "SELECT" ? (
        <div
          key={props.item.label + props.index}
          className="flex flex-col gap-1"
        >
          <label>{props.item.name}:</label>
          <select
            className="border h-[38px] rounded-[5px]"
            slug={props.item.id}
            inputType={props.item.type}
            onChange={featureChangeHandler}
          >
            <option disabled={false} selected={true} value={""}>
              انتخاب کنید
            </option>
            {props.item.options !== null &&
              props.item.options.map((option, index) => {
                return (
                  <option
                    key={option.value + props.index}
                    value={option.value}
                    selected={
                      props.item[props.item.id] === option.value ? true : false
                    }
                  >
                    {option.label}
                  </option>
                );
              })}
          </select>
        </div>
      ) : (
        <div
          key={props.item.label + props.index}
          className="flex flex-col gap-1"
        >
          <label>{props.item.name}:</label>
          <input
            className="border h-[38px] rounded-[5px] px-[12px]"
            value={newValue}
            autoComplete="false"
            slug={props.item.id}
            inputType={props.item.type}
            onChange={featureChangeHandler}
          />
        </div>
      )}
    </div>
  );
};

export default Filters;
